import api from "./api";

export const getCompetencyLibrary = () => api.get("/competencies");

export const createCompetency = (payload) => api.post("/competencies", payload);

export const updateCompetency = (competencyId, payload) => api.put(`/competencies/${competencyId}`, payload);

export const getMyCompetencyAssessment = (cycleId) => api.get(`/cycles/${cycleId}/competencies/me`);

export const saveMyCompetencyAssessment = (cycleId, payload) => api.put(`/cycles/${cycleId}/competencies/me`, payload);

export const submitMyCompetencyAssessment = (cycleId) => api.post(`/cycles/${cycleId}/competencies/me/submit`);

export const getEmployeeCompetencyAssessment = (cycleId, employeeId) =>
  api.get(`/cycles/${cycleId}/employees/${employeeId}/competencies`);

export const saveEmployeeCompetencyAssessment = (cycleId, employeeId, payload) =>
  api.put(`/cycles/${cycleId}/employees/${employeeId}/competencies`, payload);

export const submitEmployeeCompetencyAssessment = (cycleId, employeeId) =>
  api.post(`/cycles/${cycleId}/employees/${employeeId}/competencies/submit`);

export const getTeamCompetencyStatus = (cycleId) => api.get(`/cycles/${cycleId}/competencies/team`);
